import React, { useRef } from "react";
import { Box, Container, Content, ImgBox1, TextBox1 } from "./style";
import { useTranslation } from "react-i18next";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com1 = ({ t }) => {
  const ref1 = useRef();

  useScrollFadeIn(ref1);
  return (
    <Container>
      <TextBox1>
        <div>
          <span>{t("1-1")}</span>
        </div>
        <div>
          <span>{t("1-2")}</span>
          <span>{t("1-3")}</span>
        </div>
        <Box>
          <Content>
            <div>
              <img
                loading="lazy"
                src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/1f8190d0SystemIntegration_2.svg"
                alt="목록"
              />
            </div>
            <div>
              <span>{t("1-4")}</span>
              <span>{t("1-5")}</span>
            </div>
          </Content>
          <Content>
            <div>
              <img
                loading="lazy"
                src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/c5c0a52cSystemIntegration_3.svg"
                alt="목록"
              />
            </div>
            <div>
              <span>{t("1-6")}</span>
              <span>{t("1-7")}</span>
            </div>
          </Content>
          <Content>
            <div>
              <img
                loading="lazy"
                src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/6f01e498SystemIntegration_4.svg"
                alt="목록"
              />
            </div>
            <div>
              <span>{t("1-8")}</span>
              <span>{t("1-9")}</span>
            </div>
          </Content>
          <Content>
            <div>
              <img
                loading="lazy"
                src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/d869840eSystemIntegration_5.svg"
                alt="목록"
              />
            </div>
            <div>
              <span>{t("1-10")}</span>
              <span>{t("1-11")}</span>
            </div>
          </Content>
        </Box>
      </TextBox1>
      <ImgBox1 loading="lazy">
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/b7293d6dSystemIntegration_1.svg"
          alt="메인이미지"
          ref={ref1}
          className="fade-in"
        />
      </ImgBox1>
    </Container>
  );
};

export default Com1;
